import { useTranslation } from "react-i18next";
import { Linkedin, Instagram, Twitter, Youtube, Smartphone, Image as ImageIcon } from "lucide-react";
import LinkedInHeader from "@/components/social/LinkedInHeader";
import FormatTile from "@/components/social/FormatTile";
import PostMock from "@/components/social/PostMock";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

/**
 * /SocialMedia — social kit (B3-SocialMedia). Internal marketing tool,
 * super admin only (App.tsx), each template exported as a PNG at the
 * platform's real size. Figures come from config/marketing.
 */
export default function SocialMedia() {
  const { t } = useTranslation(['pages']);
  useDocumentTitle(t('pages:socialMediaKit.docTitle'));

  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6 md:py-16">
        <div className="mb-10 text-center md:mb-14">
          <span className="mb-3 block text-xs uppercase tracking-[0.2em] text-purple-400">
            {t('pages:socialMediaKit.kicker')}
          </span>
          <h1 className="text-3xl font-bold text-white md:text-5xl">{t('pages:socialMediaKit.title')}</h1>
          <p className="mx-auto mt-3 max-w-2xl text-white/50">{t('pages:socialMediaKit.subtitle')}</p>
        </div>

        <LinkedInHeader />

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <PostMock icon={Linkedin} title={t('pages:socialMediaKit.formats.linkedinSquare')} width={1200} height={1200} filename="linkedin-post-1200x1200" gradient="from-blue-500/25 to-cyan-500/25" />
          <PostMock icon={Linkedin} title={t('pages:socialMediaKit.formats.linkedinHorizontal')} width={1200} height={628} filename="linkedin-post-1200x628" gradient="from-blue-500/25 to-cyan-500/25" />
          <PostMock icon={Instagram} title={t('pages:socialMediaKit.formats.instagramPost')} width={1080} height={1080} filename="instagram-post-1080x1080" gradient="from-pink-500/25 to-rose-500/25" />
          <FormatTile icon={Smartphone} title={t('pages:socialMediaKit.formats.storyVertical')} width={1080} height={1920} filename="story-1080x1920" gradient="from-violet-500/25 to-purple-500/25" />
          <FormatTile icon={Twitter} title={t('pages:socialMediaKit.formats.twitterHeader')} width={1500} height={500} filename="x-header-1500x500" gradient="from-sky-500/25 to-cyan-500/25" />
          <FormatTile icon={Youtube} title={t('pages:socialMediaKit.formats.youtubeBanner')} width={2560} height={1440} filename="youtube-banner-2560x1440" gradient="from-red-500/25 to-orange-500/25" />
          <FormatTile icon={ImageIcon} title={t('pages:socialMediaKit.formats.carousel')} width={1080} height={1080} filename="carousel-1080x1080" gradient="from-emerald-500/25 to-green-500/25" />
        </div>
      </div>
    </div>
  );
}
